import { FC } from 'react'

// Components
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

// Logic
import { useProcedureOptionsMenuLogic } from './ProcedureOptionsMenu.logic'

// Types
import { ProcedureOptionsMenuProps } from './ProcedureOptionsMenu.types'

// Styles
import './ProcedureOptionsMenu.scss'

export const ProcedureOptionsMenu: FC<ProcedureOptionsMenuProps> = (props) => {
  const { surgery } = props
  const logic = useProcedureOptionsMenuLogic(props)

  const shouldShowOptionsButton =
    !logic.isRep &&
    (logic.flags.enableEditSurgery || logic.flags.cancelSurgeryAction) &&
    surgery.status.name !== 'SUBMITTED'

  if (!shouldShowOptionsButton) {
    return null
  }

  return (
    <div
      className="procedure-options-menu"
      onClick={(e) => e.stopPropagation()}
    >
      <IconButton
        className="more-vert-icon"
        onClick={(e) => {
          e.stopPropagation()
          logic.handleOpenOptionsMenu(e.currentTarget)
        }}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        anchorEl={logic.optionsMenuAnchor}
        open={Boolean(logic.optionsMenuAnchor)}
        onClose={(event) => logic.handleCloseOptionsMenu(event)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {logic.flags.enableEditSurgery && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation()
              logic.handleEditProcedure()
            }}
          >
            Edit Procedure
          </MenuItem>
        )}
        {logic.flags.cancelSurgeryAction && (
          <Tooltip
            title={
              !logic.canCancelSurgery(surgery)
                ? 'Cannot cancel surgery because it has implantable or biologic products'
                : ''
            }
          >
            <span>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  logic.handleCancelProcedure()
                }}
                disabled={!logic.canCancelSurgery(surgery)}
              >
                Cancel Procedure
              </MenuItem>
            </span>
          </Tooltip>
        )}
        {!surgery.preferenceCardId && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation()
              logic.handleAssignPreference()
            }}
          >
            Assign Preference Card
          </MenuItem>
        )}
        {surgery.preferenceCardId && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation()
              logic.handleUnassignPreference(surgery)
            }}
          >
            Unassign Preference Card
          </MenuItem>
        )}
      </Menu>
    </div>
  )
}
